import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface ShellContextValue {
  helpOpen: boolean;
  openHelp: (source: string) => void;
  closeHelp: (reason: 'button' | 'escape' | 'overlay' | 'back') => void;
}

const ShellContext = createContext<ShellContextValue | null>(null);

export function ShellProvider({ children }: { children: ReactNode }) {
  const [helpOpen, setHelpOpen] = useState(false);

  const openHelp = useCallback(() => setHelpOpen(true), []);
  const closeHelp = useCallback(() => setHelpOpen(false), []);

  const value = useMemo(() => ({ helpOpen, openHelp, closeHelp }), [helpOpen, openHelp, closeHelp]);
  return <ShellContext.Provider value={value}>{children}</ShellContext.Provider>;
}

export function useShell(): ShellContextValue {
  const value = useContext(ShellContext);
  if (!value) throw new Error('useShell must be used inside <ShellProvider>');
  return value;
}
